// additional stuff for complaint.js, can dynamically create elements
// it's in a separate file bacuse it needs access to our "advanced" javascript
// stuff, like translations etc.

import { jQuery as $ } from 'mk/jQuery';
import { timeAt } from 'mk2/helpers/timeformat';
import mystache from '../../old/mystache';

// FIXME: move this stuff into a common-place, for example
// comment2.js does something similar
var _userData = null;
var getUserData = function() {
    if (!_userData) {
        _userData = JSON.parse($('.complaint-user-data').html());
    }
    return _userData;
};

var ALLOWED_FORMATS = {'compact': true, 'icon-gray': true};

export function renderControl(fmt, complaintData) {
    if (!(fmt in ALLOWED_FORMATS)) {
        throw new Error('Invalid format:' + fmt);
    }
    var d = {
        assetUrl: window.ASSET_URL,
        format_compact: fmt === 'compact',
        format_icon_gray: fmt === 'icon-gray',
        postUrl: complaintData.postUrl,
        msg: complaintData.msg,
        targetId: complaintData.targetId,
    };

    return mystache.get('#complaint-control-template')(d);
};

export function renderPlaceholder(complaintData) {
    return mystache.get('#complaint-placeholder-template')({targetId: complaintData.targetId});
}

export function renderReport(complaintData) {
    // if there are no templates do not render anything
    var complaints = complaintData.complaints;
    var res = null;
    if (complaints.length === 0) {
        res = '';
    } else {
        var d = {};
        d.complaints = complaints.map(function(c) {
            var cNew = Object.assign({}, c);
            cNew.created = timeAt(new Date(cNew.created * 1000));
            return cNew;
        });
        d.deleteAllUrl = complaintData.deleteAllUrl;

        res = mystache.get('#complaint-report-template')(d);
    }
    return res;
}

export function onComplaintChange(complaintData, eventData) {
    var data = Object.assign({}, complaintData);
    if (eventData.event === 'alldeleted') {
        data.complaints = [];
    } else if (eventData.event === 'fullForm:added') {
        var complaints = data.complaints.slice(0); // let's make a copy
        var userData = getUserData();
        complaints.push({
            created: (new Date()).getTime(),
            user: userData.user,
            reason: eventData.reason,
            comment: eventData.comment,
            userProfileUrl: userData.profileUrl,
        });
        data.complaints = complaints;
    }
    return data;
}
